import { Observable } from 'rxjs';
import { GoalQuestionsRequest, GoalQuestionsResponse } from '../goal.model';
import { IAPIResponse } from '@domain/interfaces/apis/api-response.interface';

export abstract class OnboardingGateway {
  abstract getGoalQuestions(): Observable<GoalQuestionsResponse>;
  abstract addGoals(goals: GoalQuestionsRequest): Observable<IAPIResponse>;
}
